import $  from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import ConsultComponent from './app';
import './styles.scss';

export default class ConsultModule{
	constructor(config,$modules){
		if(!config){
			console.warn("Consult module requires config")
			return;
		}
	    let props = {
	    	title: config.title,
	    	items: config.items
	    }
	    $modules.each((index,el)=>{
	    	ReactDOM.render(React.createElement(ConsultComponent,props),el);
	    	$(el).data('module','');
	    })
	}
}

ConsultModule.init = function(config,$modules){
	$modules = $modules || $('[data-module="ConsultAd"]');
	if($modules.length>0){
		new ConsultModule(config,$modules);
	}
}


// WEBPACK FOOTER //
// ./src/app/consult/index.js